export default __webpack_public_path__ + "static/media/sourcing_icon.74b7a551.svg";